import cn from 'classnames';
import styles from "./Separator.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export function Separator(_ref) {
  let {
    skin = 'default',
    spacing = 'medium'
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.Separator, styles["spacing-".concat(spacing)], styles["skin-".concat(skin)])
  });
}